import { render, staticRenderFns } from "./NewLoginPage.vue?vue&type=template&id=58c15904&scoped=true&"
import script from "./NewLoginPage.vue?vue&type=script&lang=js&"
export * from "./NewLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./NewLoginPage.vue?vue&type=style&index=0&id=58c15904&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c15904",
  null
  
)

export default component.exports